import { List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutlineOutlined"

import { WW_BLUE } from "@/theme/tokens"

export default function TourList({ tours, completed = [], onStart, dense = false }) {
  return (
    <List dense={dense} disablePadding>
      {tours.map((tour) => {
        const done = completed.includes(tour.id)
        return (
          <ListItemButton key={tour.id} onClick={() => onStart(tour.id)} sx={{ borderRadius: 1 }}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              {done ? (
                <CheckCircleIcon fontSize="small" sx={{ color: "#4caf50" }} />
              ) : (
                <PlayCircleOutlineIcon fontSize="small" sx={{ color: WW_BLUE }} />
              )}
            </ListItemIcon>
            <ListItemText
              primary={tour.title}
              secondary={`${tour.summary} · ~${tour.minutes} min`}
              slotProps={{
                primary: { sx: { fontSize: 14, fontWeight: 500, color: WW_BLUE } },
                secondary: { sx: { fontSize: 12 } },
              }}
            />
          </ListItemButton>
        )
      })}
    </List>
  )
}
